export enum DriverTimeFiltration {
  LastHour = 'LastHour',
  LastTwoHours = 'LastTwoHours',
  LastDay = 'LastDay',
  LastTwoDays = 'LastTwoDays',
  AllTime = 'AllTime'
}
